var map = {
	"./view/About.vue": [
		"hiaQ",
		8
	],
	"./view/CompanyIntroduction.vue": [
		"5uVc",
		22
	],
	"./view/ContactUs.vue": [
		"CEVh",
		0,
		19
	],
	"./view/ContactUscom/CompanyProfile.vue": [
		"WRye",
		0
	],
	"./view/ContactUscom/Contact.vue": [
		"X4fB",
		0
	],
	"./view/ContactUscom/Partner.vue": [
		"y7Qe",
		0
	],
	"./view/CoreBusiness/index.vue": [
		"Uhkg",
		0,
		5
	],
	"./view/CoreBusiness/manageservice.vue": [
		"zUYx",
		0
	],
	"./view/CoreBusiness/noPage.vue": [
		"KauO",
		9
	],
	"./view/CoreBusiness/resource.vue": [
		"3Hy2",
		0
	],
	"./view/HomePage.vue": [
		"uRyO",
		0,
		1
	],
	"./view/JobChance.vue": [
		"BLIj",
		18
	],
	"./view/News.vue": [
		"WEI3",
		0,
		4
	],
	"./view/NewsInformation.vue": [
		"JcyW",
		7
	],
	"./view/PageView.vue": [
		"IeuH",
		15
	],
	"./view/Rentacar.vue": [
		"mTJ4",
		11
	],
	"./view/SINP.vue": [
		"frbV",
		0,
		13
	],
	"./view/Service.vue": [
		"X7sC",
		3
	],
	"./view/ServiceDetail.vue": [
		"JxTP",
		17
	],
	"./view/Soft.vue": [
		"1ctp",
		0,
		20
	],
	"./view/Software.vue": [
		"RxBX",
		0,
		21
	],
	"./view/Software_bigData.vue": [
		"kIi0",
		14
	],
	"./view/Software_smartTown.vue": [
		"7w7R",
		16
	],
	"./view/VISA.vue": [
		"jwOM",
		0,
		12
	],
	"./view/home/News.vue": [
		"aUUP",
		0,
		6
	],
	"./view/home/Release.vue": [
		"1Bsy",
		0
	],
	"./view/home/Service.vue": [
		"GKG+",
		2
	],
	"./view/home/scrollTable.vue": [
		"2kgW",
		0
	],
	"./view/home/scrollTable2.vue": [
		"xew3",
		0
	],
	"./view/news/NewsDetail.vue": [
		"Hle7",
		0
	],
	"./view/news/NewsList.vue": [
		"Hw7j",
		0
	],
	"./view/news/Release.vue": [
		"+B0N",
		0,
		10
	],
	"./view/snip/SnipDetail.vue": [
		"/R4v",
		0
	],
	"./view/snip/sinpVisaCom.vue": [
		"4WTC",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "AMsx";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^\.\/view.*\.vue$
// module id = AMsx
// module chunks = 24